import firebase from 'firebase'
import User from "./user.model";
import { AppService } from '../app.service';
import { UUID } from '../../util/prototypes';
import { CustomClass } from './custom-class.model'



export class Typography extends CustomClass {

    constructor(payload) {
        super(payload);
        if (payload) {
            this.base = payload.base;
            this.ratio = payload.ratio;
            this.lineHeight = payload.lineHeight;
        } else {
            this.base = 16;
            this.ratio = 1.067;
            this.lineHeight = 1.3;
        }
        this.screen = 'lg';
        this.types = [];
        this.applyRatio();
    }

    get style() {
        return `${this.topLeft}px ${this.topRight}px ${this.bottomLeft}px ${this.bottomRight}px`;
    }

    set(payload) {
        Object.assign(this, { ...this, ...payload })
        return this;
    }

    get styleSheets() {
        const css = this.types.map((item, i, arr) => {
            let tag = 'h';
            if (i == 0) {
                tag = 'p';
            } else {
                tag = 'h' + (i);
            }
            return `#wrapper ${tag}{line-height:${(this.lineHeight*item).toFixed(2)}px;font-size:${this.getPx(item)} !important;}`
        });
        // return this.getMediaQuery(css);
        return css;
    }

    static list(callback) {
        AppService.allBorderRadius((snapshot) => {
            this.snapshot = snapshot;
            const list = [];
            snapshot.docs.forEach((item) => {
                const data = item.data();
                list.push(new Typography({ ...data, doc: item }))
            })
            callback(list);
        });
    }

    static loadTypographyToDom(callback) {
        const stylsheet = document.createElement("style");
        stylsheet.setAttribute("type", "text/css");
        stylsheet.setAttribute("id", "borderRadius");
        Typography.list((list) => {
            const css = list.map((item) => item.className).join(' ');
            stylsheet.innerText = css;
            document.querySelector("head").appendChild(stylsheet);
            callback(list);
        })
    }

    get first() {
        return this.types[0] + 'px';
    }

    get last() {
        return this.types[this.types.length - 1] + 'px';
    }

    applyRatio() {
        this.types = [this.base];
        for (let i = 1; i < 7; i++) {
            this.types.push(this.types[i - 1] * this.ratio);
        }

        this.types = this.types.reverse();
    }

    getPx(item) {
        return (+item).toFixed(3) + 'px'
    }

    getRem(item) {
        return (+item / this.base).toFixed(3) + 'rem'
    }

    async create() {
        try {
            const data = {
                ...this.toJson(),
                name: `br-${this.name.toLowerCase()}`,
                timestamp: this.timestamp,
                uid: this.user.uid,
            };
            const resp = await AppService.addBorderRadius(data);
            this.doc = resp;
            return this;
        } catch (error) {
            console.error("Error in BorderRadius.create", error);
            throw error;
        }
    }

}